import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatToReactComponent } from 'bloko/common/trl';

import HumanDate, { ShowYear } from 'src/components/HumanDate';
import translation from 'src/components/translation';
import { Gender } from 'src/models/resume/resumeCommon.types';

const TrlKeys = {
    [Gender.Female]: 'negotiations.employer.nonAppearance.female',
    [Gender.Male]: 'negotiations.employer.nonAppearance.male',
    [Gender.Unknown]: 'negotiations.employer.nonAppearance.male',
};

interface Props {
    date: string;
    gender: Gender;
}

const LastNonAppearanceComplaintDate: TranslatedComponent<Props> = ({ date, gender, trls }) => {
    return (
        <span data-qa="non-appearance-complaint-date">
            {formatToReactComponent(trls[TrlKeys[gender]], {
                '{0}': <HumanDate date={date} showYear={ShowYear.NotCurrent} />,
            })}
        </span>
    );
};

export default translation(LastNonAppearanceComplaintDate);
